
const edit = {

	init() {

		// Vervang u20ac voor euro teken
		$('.form-section input').each(function() {
			$(this).val($(this).val().replace(/u20ac/g, '€'));
		});

		// Initieer tab verwijder functie on focus, blue en keyup van elke input
		$('body').on('focus blur keyup', 'input', function() {
			$(this).val(edit.trimTabsFromString($(this).val()));
		});

	},

	// Functie om tabs te verwijderen uit string
	trimTabsFromString: function(i) {
		return i.replace('\t', '');
	}

};

export default edit;
